import { HeartFilledIcon, HeartIcon } from '@repo/icons';
import { Button, type ButtonProps } from '@repo/ui/button';

type GameCardButton = {
  label?: string;
  props: ButtonProps;
};

type GameCardInfoLayerProps = {
  primaryButton: GameCardButton;
  secondaryButton: GameCardButton;
  favoriteButtonProps: GameCardButton;
  infoLayerFooterRenderer: React.ReactNode;
  playForFun: boolean;
  isFavoriteGame: boolean;
};

const GameCardInfoLayer = ({
  primaryButton,
  secondaryButton,
  favoriteButtonProps,
  infoLayerFooterRenderer,
  playForFun,
  isFavoriteGame,
}: GameCardInfoLayerProps) => (
  <div className="absolute left-0 top-0 z-30 h-full w-full duration-200 vt-atoms-game-card-normal-text vt-atoms-game-card-active-overlay-bg animate-in fade-in @container">
    <div className="space-y-1.5 px-1">
      <header className="flex h-10 items-center justify-center">
        {favoriteButtonProps && (
          <button
            className="flex size-7 items-center justify-center rounded-full vt-atoms-ratings-rated-star"
            {...favoriteButtonProps}
          >
            {isFavoriteGame ? <HeartFilledIcon /> : <HeartIcon />}
          </button>
        )}
      </header>
      <main className="flex h-20 flex-col justify-center space-y-1.5 px-2 @[200px]:px-8">
        {primaryButton && (
          <Button
            size="sm"
            className="w-full rounded-3xl vt-font-highlight-font-family vt-text-size-small sm:vt-text-size-small-sm"
            {...(primaryButton.props || {})}
          >
            {primaryButton.label}
          </Button>
        )}
        {playForFun && secondaryButton && (
          <Button
            size="sm"
            variant="tertiary"
            className="w-full rounded-3xl vt-font-highlight-font-family vt-text-size-small sm:vt-text-size-small-sm"
            {...((secondaryButton?.props || {}) as any)}
          >
            {secondaryButton.label}
          </Button>
        )}
      </main>
      {infoLayerFooterRenderer && (
        <footer className="flex h-10 flex-col items-center justify-center">{infoLayerFooterRenderer}</footer>
      )}
    </div>
  </div>
);

export default GameCardInfoLayer;
